/// <amd-module name="SuiteCommerce.InventoryDisplay.Message.RegularItem.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.InventoryDisplay.Message.RegularItem.View", ["require", "exports", "SuiteCommerce.InventoryDisplay.InventoryDisplay.Configuration", "SuiteCommerce.InventoryDisplay.Message.View", "suitecommerce_inventorydisplay.tpl"], function (require, exports, InventoryDisplay_Configuration_1, InventoryDisplay_Message_View_1, suitecommerce_inventorydisplay) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemMessageView = /** @class */ (function (_super) {
        __extends(ItemMessageView, _super);
        function ItemMessageView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = suitecommerce_inventorydisplay;
            return _this;
        }
        ItemMessageView.prototype.isInStock = function () {
            return this.getQuantityAvailable() > 0;
        };
        ItemMessageView.prototype.getStockMessage = function () {
            var stockMessage = '';
            if (this.isInStock()) {
                stockMessage = this.item.custitem_ns_sc_ext_id_stock_message
                    || InventoryDisplay_Configuration_1.InventoryDisplayConfiguration.inStockMessageForRegularItems;
                if (this.isUnderThreshold()) {
                    stockMessage = this.item.custitem_ns_sc_ext_id_low_stock_msg ||
                        InventoryDisplay_Configuration_1.InventoryDisplayConfiguration.lowStockMessage;
                    stockMessage = this.replaceQuantityPlaceholder(stockMessage);
                }
            }
            else if (this.item.isbackorderable) {
                stockMessage = this.item.custitem_ns_sc_ext_id_bo_msg
                    || InventoryDisplay_Configuration_1.InventoryDisplayConfiguration.backorderMessageForRegularItems;
            }
            return stockMessage;
        };
        return ItemMessageView;
    }(InventoryDisplay_Message_View_1.InventoryDisplayMessageView));
    exports.ItemMessageView = ItemMessageView;
});
